import SpotDescriptor from './SpotDescriptor';

export default SpotDescriptor;
